interface PlaceOption {
  id: string
  status?: string
  isDraft?: boolean
}

/** The place a page opens on: the one asked for, else the first published one, else the first. */
export function pickPlace<T extends PlaceOption>(
  listings: readonly T[],
  wantedId: string | undefined,
): T | null {
  return (
    listings.find((listing) => listing.id === wantedId) ??
    listings.find((listing) => listing.status === 'Published' && !listing.isDraft) ??
    listings[0] ??
    null
  )
}

/** The places a picker offers: the first page, with the place asked for in front when it is further down. */
export function placeOptions<T extends PlaceOption>(
  firstPage: readonly T[],
  requested: T | undefined,
): T[] {
  return requested && !firstPage.some((place) => place.id === requested.id)
    ? [requested, ...firstPage]
    : [...firstPage]
}
